class Zepter_V2_TopNavigation {
    constructor() {
        this.container = document.getElementById("V2_TopNavigation_Wrapper");
        this.elTopNavigationRow1 = document.getElementById("V2_TopNavigation_Row1");
        this.elTopNavigationRow2 = document.getElementById("V2_TopNavigation_Row2");
        this.elTopNavigationRow3 = document.getElementById("V2_TopNavigation_Row3");
        this.scrollYToMinimalize = 150;
        // Jeśli brak wymaganych do pracy kontenerów
        if (!this.container || !this.elTopNavigationRow1 || !this.elTopNavigationRow2 || !this.elTopNavigationRow3) {
            // Przerwij działanie
            return;
        }
        // Obsługa bodyPaddingTop
        this.bodyPadingTop();
        window.addEventListener("resize", () => { this.bodyPadingTop(); });
        new ResizeObserver(() => { this.bodyPadingTop(); }).observe(this.container);
        // Obsługa window scroll
        window.addEventListener("scroll", () => { this.onScroll(); });
    }
    bodyPadingTop() {
        const navHeight = this.elTopNavigationRow1.clientHeight + this.elTopNavigationRow2.clientHeight + this.elTopNavigationRow3.clientHeight;
        document.documentElement.style.setProperty("--v2-topnavigation-height", `${navHeight}px`);
        document.body.style.paddingTop = "";
        //console.log(navHeight)
    }
    onScroll() {
        // Jeśli scrollbar jest przesunięty w dół
        if (window.scrollY > this.scrollYToMinimalize) {
            // Ustaw skalę dla całego TopNavigation
            if (parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--v2-topnavigation-scale")) != 0.75) {
                document.documentElement.style.setProperty("--v2-topnavigation-scale", `0.75`);
            }
        }
        // Jeślis crollbar jest na samej górze
        else {
            // Ustaw skalę dla całego TopNavigation
            if (parseInt(getComputedStyle(document.documentElement).getPropertyValue("--v2-topnavigation-scale")) != 1) {
                document.documentElement.style.setProperty("--v2-topnavigation-scale", `1`);
            }
        }
    }
}
// Uruchom klasę zarządzającą górnym elementem nawigacyjnym
//window.addEventListener('DOMContentLoaded', (event) => {
new Zepter_V2_TopNavigation();
//});


class Zepter_V2_TopNavigation_AdditionalMenu {
    constructor() {
        this.container = document.getElementById("V2_TopNavigation_Row3");
        // Jeśli brak kontenera gównego
        if (!this.container) {
            // Zakończ działanie tej klasy
            return;
        }
        // Obsługa elementów otwierających modal
        this.LinksWithModalController();
    }
    LinksWithModalController() {
        // Ustal elementy, które mają otwierać modal
        const modalItems = this.container.querySelectorAll("[data-is-modal]");
        // Przetwarzaj elementy posiadające modal
        modalItems.forEach((elItemWithModal) => {
            var _a, _b, _c;
            if (elItemWithModal.nodeType === 1) {
                const modalHtml = elItemWithModal.querySelector("[data-modal]");
                const modalIcon = elItemWithModal.getElementsByClassName("V2_TopNavigation_row3_menuItemIcon");
                //console.log(modalIcon[0].firstElementChild)
                // Jeśli zawartośc dla modala istnieje
                if (modalHtml) {
                    // Ustal tytuł modala
                    const modalTitle = ((_a = modalHtml.dataset.modalTitle) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? modalHtml.dataset.modalTitle // Pobierz tytuł wpisany w CMS
                        : (_b = elItemWithModal.querySelector("a")) === null || _b === void 0 ? void 0 : _b.innerText.trim(); // Pobierz tytuł z nazwy klinku wywołującego modal
                    // Stwórz element z tytułem dla modala
                    const elModalTitleWrapper = document.createElement("div");
                    const elModalTitleLabel = document.createElement("div");
                    let elModalTitleIcon;
                    if (modalIcon.length === 1) {
                        elModalTitleIcon = modalIcon[0].firstElementChild.cloneNode();
                    }
                    // Konfiuruj elementy tytułu modala
                    elModalTitleWrapper.style.display = "flex";
                    elModalTitleWrapper.style.flexDirection = "row";
                    elModalTitleWrapper.style.alignItems = "center";
                    elModalTitleWrapper.style.gap = "0.5em";
                    elModalTitleLabel.innerText = modalTitle;
                    elModalTitleLabel.style.fontSize = "1.5em";
                    elModalTitleLabel.style.lineHeight = "1";
                    elModalTitleIcon.width = 30;
                    elModalTitleIcon.height = 30;
                    elModalTitleIcon.style.filter = "blur(0.04em)";
                    // Dodaj elementy tytułu do DOM
                    elModalTitleWrapper.appendChild(elModalTitleIcon);
                    elModalTitleWrapper.appendChild(elModalTitleLabel);
                    // Obsługa kliknięcia w link otwierający modal
                    (_c = elItemWithModal.querySelector("a")) === null || _c === void 0 ? void 0 : _c.addEventListener("click", () => {
                        // Ustawienia modala
                        let modalProps = {
                            modalId: `AdditionalMenu_Modal_${Math.floor(Math.random() * 100)}`,
                            modalSize: "xl",
                            modalCloseButton: true,
                            modalCloseuttonColor: "white",
                            modalTitle: elModalTitleWrapper,
                            //modalTitle: elItemWithModal.querySelector("a")?.innerText.trim(),
                            modalHeaderAlign: "center",
                            modalHeaderBgColor: "black",
                            modalHeaderTextColor: "white",
                            modalDialogCentered: true,
                            modalBody: modalHtml
                        };
                        // Otwórz modal
                        const modal = new Modal(modalProps);
                        modal.show();
                    });
                }
            }
        });
    }
}
new Zepter_V2_TopNavigation_AdditionalMenu();

class Zepter_V2_TopNavigation_MainMenu {
    constructor() {
        this.topNavigationWrapper = document.getElementById("V2_TopNavigation_Wrapper");
        this.topNavigationRow2 = document.getElementById("V2_TopNavigation_Row2");
        this.rowWrapper = document.getElementById("V2_TopNavigation_Row2_RowWrapper");
        this.menuData = document.getElementById("V2_TopNavigation_Row2_MenuData");
        this.menuWrapper = document.getElementById("V2_TopNavigation_Row2_MenuWrapper");
        this.menuHighlight = null;
        this.submenuWrapper = document.getElementById("V2_TopNavigation_Row2_SubmenuWrapper");
        this.pcBreakpoint = 1200;
        // Configuration
        this.showSubmenuOnClick = true;
        if (!this.menuWrapper || !this.submenuWrapper) {
            return;
        }
        this.renderMenu();
    }
    renderMenu() {
        const menuDataL0 = this.menuData.children;
        this.menuWrapper.innerHTML = "";
        for (let i = 0; i < menuDataL0.length; i++) {
            const showSubmenu = (elUlSubmenuOrigin, submenuTitle, elUlLogotypesOrigin) => {
                this.showSubmenu(elUlSubmenuOrigin, submenuTitle, elUlLogotypesOrigin);
            };
            let elAOrigin = menuDataL0.item(i).querySelector("a");
            let elUlSubmenuOrigin = menuDataL0.item(i).querySelector("ul.submenu");
            let elUlLogotypesOrigin = menuDataL0.item(i).querySelector("ul.logotypes");
            if (elAOrigin) {
                // Stwórz [elA]
                const elA = document.createElement("a");
                // Konfiguruj [elA]
                elA.href = elAOrigin.href;
                elA.target = elAOrigin.target;
                elA.innerText = elAOrigin.innerText.trim();
                elA.classList.add("V2_TopNavigation_row2_menuItem");
                // Dodaj elementy do DOM
                this.menuWrapper.appendChild(elA);
                if (elUlSubmenuOrigin) {
                    // Jeśli submenu ma się pojawiać po kliknięciu w link L0
                    if (this.showSubmenuOnClick) {
                        // onClick dla [elA]
                        elA.addEventListener("click", (e) => {
                            // Jeśli ilość kliknęć jest <= 1 (jest to pierwsze kliknięcie w [elA])
                            if (this.countClicksOnElement(elA) <= 1) {
                                // Zablokuj standardowe działanie <a>
                                e.preventDefault();
                                // Ustaw podświetlenie dla [elA]
                                this.showMenuHighlight(elA);
                                // Usuń style podświetlenia z równorzędnych elementów względem [elA]
                                this.removeClassFromElement(this.menuWrapper.querySelectorAll("a"), "V2_TopNavigation_row2_menuItem_isSelected");
                                // Dodaj styl podświetlenia dla wybranego elementu [elA]
                                elA.classList.add("V2_TopNavigation_row2_menuItem_isSelected");
                                // Ustaw licznik kliknięć w element [elA]
                                this.countClicksOnElementReset(this.menuWrapper.querySelectorAll("a"));
                                this.countClicksOnElement(elA);
                                // Pokaż submenu
                                showSubmenu(elUlSubmenuOrigin, elAOrigin.innerText, elUlLogotypesOrigin);
                            }
                        }, false);
                    }
                    // Jeśli submenu ma się pojawiać po najecaniu w link L0
                    else {
                        // onMouseOver dla [elA]
                        elA.addEventListener("mouseover", () => {
                            // Ustaw podświetlenie dla [elA]
                            this.showMenuHighlight(elA);
                            // Usuń style podświetlenia z równorzędnych elementów względem [elA]
                            this.removeClassFromElement(this.menuWrapper.querySelectorAll("a"), "V2_TopNavigation_row2_menuItem_isSelected");
                            // Dodaj styl podświetlenia dla wybranego elementu [elA]
                            elA.classList.add("V2_TopNavigation_row2_menuItem_isSelected");
                            // Pokaż submenu
                            showSubmenu(elUlSubmenuOrigin, elAOrigin.innerText, elUlLogotypesOrigin);
                        }, false);
                    }
                }
            }
        }
        // onMouseLeave dla całego paska górnego
        this.topNavigationWrapper.addEventListener("mouseleave", () => {
            // Jeśli submenu ma się pojawiać po kliknięciu w link L0
            if (this.showSubmenuOnClick) {
                // Resetuj licznik kliknięć w element [elA]
                this.countClicksOnElementReset(this.menuWrapper.querySelectorAll("a"));
            }
            // Usuń podświetlenie dla [elA]
            this.hideMenuHighlight();
            // Usuń style podświetlenia z równorzędnych elementów względem [elA]
            this.removeClassFromElement(this.menuWrapper.querySelectorAll("a"), "V2_TopNavigation_row2_menuItem_isSelected");
            // Ukryh submenu
            this.hideSubmenu();
        });
        // Jeśli [topNavigationRow2] zmienia rozmiar
        new ResizeObserver(() => {
            // Wywyołaj event [mouseleave] aby ukryć submenu
            this.topNavigationWrapper.dispatchEvent(new Event("mouseleave"));
        }).observe(this.topNavigationRow2);
        // Zarządzaj w którym rodzicu ma być element z submenu
        this.submenuContainerChangeParent();
    }
    showMenuHighlight(elA) {
        // Jeśli [menuHighlight] nie został jeszcze utworzony
        if (!this.menuHighlight) {
            // Stwórz [menuHighlight]
            this.menuHighlight = document.createElement("div");
            // Konfiguruj [menuHighlight]
            this.menuHighlight.classList.add("V2_TopNavigation_row2_menuHighlight");
            // Dodaj do DOM
            this.menuWrapper.appendChild(this.menuHighlight);
        }
        // Pobierz dane pozycji i rozmiaru dla [elA]
        const menuWrapperRect = this.menuWrapper.getBoundingClientRect();
        const elARect = elA.getBoundingClientRect();
        // Pokaż [menuHighlight]
        this.menuHighlight.style.setProperty("--menu-highlight-opacity", `1`);
        // Ustal rozmiar i położenie [menuHighlight]
        var cfg = {};
        cfg.opacity = 0.25;
        cfg.paddingX = 10;
        cfg.paddingY = 5;
        cfg.width = elA.clientWidth + (cfg.paddingX * 2);
        cfg.height = elA.clientHeight + (cfg.paddingY * 2);
        cfg.left = elARect.x - menuWrapperRect.x - cfg.paddingX;
        cfg.top = elARect.y - menuWrapperRect.y - cfg.paddingY;
        // Ustaw zmienne CSS dla [menuHighlight]
        this.menuHighlight.style.setProperty("--menu-highlight-scale-x", `1`);
        this.menuHighlight.style.setProperty("--menu-highlight-scale-y", `1`);
        this.menuHighlight.style.setProperty("--menu-highlight-opacity", `${cfg.opacity}`);
        this.menuHighlight.style.setProperty("--menu-highlight-width", `${cfg.width}px`);
        this.menuHighlight.style.setProperty("--menu-highlight-height", `${cfg.height}px`);
        this.menuHighlight.style.setProperty("--menu-highlight-left", `${cfg.left}px`);
        this.menuHighlight.style.setProperty("--menu-highlight-top", `${cfg.top}px`);
    }
    hideMenuHighlight() {
        // Jeśli [menuHighlight] me jest dostępne
        if (!this.menuHighlight) {
            return;
        }
        // Ukryj [menuHighlight]
        this.menuHighlight.style.setProperty("--menu-highlight-opacity", `0`);
        // Ustaw rozmiar [menuHighlight]
        this.menuHighlight.style.setProperty("--menu-highlight-scale-x", `0`);
        this.menuHighlight.style.setProperty("--menu-highlight-scale-y", `0`);
        // Ustaw pozycję [menuHighlight]
        //this.menuHighlight.style.setProperty("--menu-highlight-translate-x", `0`)
        //this.menuHighlight.style.setProperty("--menu-highlight-translate-y", `0`)
    }
    renderSubmenuL0Old(submenuData) {
        const elItemsL0 = document.createElement("div");
        elItemsL0.classList.add("V2_TopNavigation_row2_submenuL0_ItemsWrapper");
        //elItemsL0.style.border = "solid 1px red"
        let column = -1;
        let row = -1;
        var elItemsColumn;
        // Pętla L0
        Array.from(submenuData.childNodes).filter(el => el.nodeName.toLowerCase() == "li").forEach((elLiOriginL0) => {
            var _a, _b;
            if (column == -1) {
                column = 0;
                row = 0;
                elItemsColumn = document.createElement("div");
                elItemsColumn.classList.add("V2_TopNavigation_row2_submenuL0_ItemsColumn");
                elItemsColumn.dataset.column = `${column}`;
            }
            let elItemL0 = document.createElement("div");
            let elAL0 = document.createElement("a");
            // Konfiguruj [elItemL0]
            elItemL0.classList.add("V2_TopNavigation_row2_submenuL0_ItemWrapper");
            // Konfiguruj <a>
            elAL0.classList.add("V2_TopNavigation_row2_submenuL0_AnchorWrapper");
            elAL0.href = (_a = elLiOriginL0.querySelector("a")) === null || _a === void 0 ? void 0 : _a.href;
            elAL0.innerText = (_b = elLiOriginL0.querySelector("a")) === null || _b === void 0 ? void 0 : _b.innerText.trim();
            // Dodaj elementy do DOM
            elItemsL0.appendChild(elItemL0);
            elItemL0.appendChild(elAL0);
            // Submenu
            const elUlOriginL1 = elLiOriginL0.querySelector("ul");
            //console.log(`elAL0.innerText submenu [${elUlOriginL1 ? 'TAK' : 'NIE'}]`)
            elUlOriginL1 ? elItemL0.appendChild(this.renderSubmenuL1(elUlOriginL1)) : null;
        });
        return elItemsL0;
    }
    renderSubmenuL0(submenuData) {
        const elItemsL0 = document.createElement("div");
        elItemsL0.classList.add("V2_TopNavigation_row2_submenuL0_ItemsWrapper");
        //elItemsL0.style.border = "solid 1px red"
        let column = 0;
        let row = 0;
        let newColumn = true;
        var elItemsColumn;
        // Pętla L0
        Array.from(submenuData.childNodes).filter(el => el.nodeName.toLowerCase() == "li").forEach((elLiOriginL0) => {
            var _a, _b, _c;
            if (newColumn || ((_a = elLiOriginL0.dataset.initNewColumn) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim()) == "true") {
                column += 1;
                row = 1;
                elItemsColumn = document.createElement("div");
                elItemsColumn.classList.add("V2_TopNavigation_row2_submenuL0_ItemsColumn");
                elItemsColumn.dataset.column = `${column}`;
                elItemsColumn.style.gridColumn = `${column}`;
                elItemsL0.appendChild(elItemsColumn);
                newColumn = false;
            }
            let elItemL0 = document.createElement("div");
            let elAL0 = document.createElement("a");
            // Konfiguruj [elItemL0]
            elItemL0.classList.add("V2_TopNavigation_row2_submenuL0_ItemWrapper");
            elItemL0.dataset.column = `${column}`;
            elItemL0.dataset.row = `${row}`;
            // Konfiguruj <a>
            elAL0.classList.add("V2_TopNavigation_row2_submenuL0_AnchorWrapper");
            elAL0.href = (_b = elLiOriginL0.querySelector("a")) === null || _b === void 0 ? void 0 : _b.href;
            elAL0.innerText = (_c = elLiOriginL0.querySelector("a")) === null || _c === void 0 ? void 0 : _c.innerText.trim();
            // Dodaj elementy do DOM
            elItemsColumn.appendChild(elItemL0);
            elItemL0.appendChild(elAL0);
            // Podbij wartość row
            row += 1;
            // Submenu
            const elUlOriginL1 = elLiOriginL0.querySelector("ul");
            //console.log(`elAL0.innerText submenu [${elUlOriginL1 ? 'TAK' : 'NIE'}]`)
            elUlOriginL1 ? elItemL0.appendChild(this.renderSubmenuL1(elUlOriginL1)) : null;
        });
        return elItemsL0;
    }
    renderSubmenuL1(submenuData) {
        const elItemsL1 = document.createElement("div");
        elItemsL1.classList.add("V2_TopNavigation_row2_submenuL1_ItemsWrapper");
        // Pętla L1
        Array.from(submenuData.childNodes).filter(el => el.nodeName.toLowerCase() == "li").forEach((elLiOriginL1) => {
            var _a, _b;
            let elItemL1 = document.createElement("div");
            let elAL1 = document.createElement("a");
            // Sprawdź czy link jest nagłówkiem sekcji [articles]
            let isArticlesItem = elLiOriginL1.classList.contains("articles");
            // Jeśli link nie jest nagłówkiem [articles]
            if (!isArticlesItem) {
                // Konfiguruj [elItemL0]
                elItemL1.classList.add("V2_TopNavigation_row2_submenuL1_ItemWrapper");
                // Konfiguruj <a>
                elAL1.classList.add("V2_TopNavigation_row2_submenuL1_AnchorWrapper");
                elAL1.href = (_a = elLiOriginL1.querySelector("a")) === null || _a === void 0 ? void 0 : _a.href;
                elAL1.innerText = (_b = elLiOriginL1.querySelector("a")) === null || _b === void 0 ? void 0 : _b.innerText.trim();
                // Dodaj elementy do DOM
                elItemsL1.appendChild(elItemL1);
                elItemL1.appendChild(elAL1);
                // Submenu
                const elUlOriginL2 = elLiOriginL1.querySelector("ul");
                //elUlOriginL2 ? elItemL1.appendChild(this.renderSubmenuL2(elUlOriginL2)) : null
            }
            // Jesli to submenu zawiera artykuły do czytania
            else {
                // Articles submenu
                elItemsL1.appendChild(this.renderSubmenuArticles(elLiOriginL1));
            }
        });
        return elItemsL1;
    }
    renderSubmenuL2(submenuData) {
        const elItemsL2 = document.createElement("div");
        elItemsL2.classList.add("V2_TopNavigation_row2_submenuL2_ItemsWrapper");
        return elItemsL2;
    }
    renderSubmenuArticles(submenuArticlesData) {
        const elItemsArticles = document.createElement("div");
        elItemsArticles.classList.add("V2_TopNavigation_row2_submenuArticles_ItemsWrapper");
        if (submenuArticlesData.querySelector("ul")) {
            // Element z nagłówkiem
            const elHeader = document.createElement("div");
            // Konfiguruj [elHeader]
            elHeader.classList.add("V2_TopNavigation_row2_submenuArticles_Header");
            elHeader.innerText = submenuArticlesData.querySelector("a").innerText.trim() + ":";
            // Dodaj elementy do DOM
            elItemsArticles.appendChild(elHeader);
            // Pętla Articles
            Array.from(submenuArticlesData.querySelector("ul").childNodes).filter(el => el.nodeName.toLowerCase() == "li").forEach((elLiOriginArticle) => {
                var _a, _b;
                let elItemArticle = document.createElement("div");
                let elListIcon = document.createElement("span");
                let elAArticle = document.createElement("a");
                // Konfiguruj [elItemL0]
                elItemArticle.classList.add("V2_TopNavigation_row2_submenuArticles_ItemWrapper");
                // Konfiguruj [list icon]
                elListIcon.classList.add("V2_TopNavigation_row2_submenuArticles_IconWrapper");
                elListIcon.innerHTML = "&bull;";
                // Konfiguruj <a>
                elAArticle.classList.add("V2_TopNavigation_row2_submenuArticles_AnchorWrapper");
                elAArticle.innerText = (_a = elLiOriginArticle.querySelector("a")) === null || _a === void 0 ? void 0 : _a.innerText.trim();
                elAArticle.href = (_b = elLiOriginArticle.querySelector("a")) === null || _b === void 0 ? void 0 : _b.href;
                // Dodaj elementy do DOM
                elItemsArticles.appendChild(elItemArticle);
                elItemArticle.appendChild(elListIcon);
                elItemArticle.appendChild(elAArticle);
            });
        }
        //console.log(elItemsArticles)
        return elItemsArticles;
    }
    renderSubmenuLogotypes(logotypesData) {
        const elItemsLogotypes = document.createElement("div");
        elItemsLogotypes.classList.add("V2_TopNavigation_row2_submenuLogotypes_itemsWrapper");
        // Pętla Logotypes
        Array.from(logotypesData.childNodes).filter(el => el.nodeName.toLowerCase() == "li").forEach((elLiOriginLogo) => {
            var _a, _b;
            let elItemLogo = document.createElement("div");
            let elALogo = document.createElement("a");
            let elImgLogo = document.createElement("img");
            // Konfiguruj [elItemL0]
            elItemLogo.classList.add("V2_TopNavigation_row2_submenuLogotypes_itemWrapper");
            // Konfiguruj <a>
            elALogo.classList.add("V2_TopNavigation_row2_submenuLogotypes_anchorWrapper");
            elALogo.href = (_a = elLiOriginLogo.querySelector("a")) === null || _a === void 0 ? void 0 : _a.href;
            //elALogo.innerText = elLiOriginLogo.querySelector("a")?.innerText.trim()
            // Konfiguruj <img>
            elImgLogo.src = (_b = elLiOriginLogo.querySelector("img")) === null || _b === void 0 ? void 0 : _b.src;
            elImgLogo.classList.add("V2_TopNavigation_row2_submenuLogotypes_imgItem");
            // Dodaj elementy do DOM
            elItemsLogotypes.appendChild(elItemLogo);
            elItemLogo.appendChild(elALogo);
            elALogo.appendChild(elImgLogo);
        });
        return elItemsLogotypes;
    }
    renderBanner(submenuData, submenuTitle) {
        var _a;
        // Dodaj banner sekcji do submenu
        const sectionBannerImgUrl = (_a = submenuData === null || submenuData === void 0 ? void 0 : submenuData.parentElement) === null || _a === void 0 ? void 0 : _a.dataset.sectionBanner;
        // Stwórz elementy
        let elBannerWrapper = document.createElement("div");
        let elTitleWrapper = document.createElement("div");
        // Konfiguruj [elBannerWrapper]
        elBannerWrapper.classList.add("V2_TopNavigation_row2_submenuL0_BannerWrapper");
        // Konfiguruj [elTitleWrapper]
        elTitleWrapper.classList.add("V2_TopNavigation_row2_submenuL0_BannerTitleWrapper");
        elTitleWrapper.innerText = submenuTitle.trim();
        // Jeśli istnieje obrazek dla tej sekcji sumbenu
        if (sectionBannerImgUrl) {
            let elBannerImage = document.createElement("img");
            // Konfiguruj [elBannerImage]
            elBannerImage.classList.add("V2_TopNavigation_row2_submenuL0_BannerImage");
            elBannerImage.src = sectionBannerImgUrl;
            // Dodaj elementy do DOM
            elBannerWrapper.appendChild(elBannerImage);
        }
        // Dodaj [elTitleWrapper] do DOM
        elBannerWrapper.appendChild(elTitleWrapper);
        return elBannerWrapper;
    }
    renderCloseButton() {
        const elButton = document.createElement("button");
        elButton.innerText = "X";
        elButton.classList.add("V2_TopNavigation_row2_submenuCloseButton");
        elButton.addEventListener("click", () => {
            this.topNavigationWrapper.dispatchEvent(new Event("mouseleave"));
        });
        return elButton;
    }
    getSubmenuTransitionDurationMs() {
        return parseFloat(this.submenuWrapper.style.getPropertyValue("--transition-duration")) * 1000;
    }
    submenuContainerChangeParent() {
        const fnUpdateParent = () => {
            const currentParent = this.submenuWrapper.parentElement;
            if (window.innerWidth < this.pcBreakpoint && currentParent.id !== "V2_TopNavigation_Wrapper") {
                this.topNavigationWrapper.appendChild(this.submenuWrapper);
            }
            else if (window.innerWidth >= this.pcBreakpoint && currentParent.id !== "V2_TopNavigation_Row2") {
                this.topNavigationRow2.appendChild(this.submenuWrapper);
            }
        };
        window.addEventListener("resize", () => { fnUpdateParent(); });
        fnUpdateParent();
    }
    showSubmenu(submenuData, submenuTitle, logotypesData) {
        const elSubmenu = this.renderSubmenuL0(submenuData);
        const elBanner = this.renderBanner(submenuData, submenuTitle);
        const elLogotypes = this.renderSubmenuLogotypes(logotypesData);
        const elCloseButton = this.renderCloseButton();
        this.submenuWrapper.innerHTML = "";
        // Dodaj container aby zachować ograniczoną szerokość submenu
        const elContainer = document.createElement("div");
        const elRow = document.createElement("div");
        const elCol = document.createElement("div");
        this.submenuWrapper.appendChild(elContainer);
        elContainer.appendChild(elRow);
        elRow.appendChild(elCol);
        // Konfiguruj [elContainer] [elRow] [elCol]
        elContainer.classList.add("container", "V2_TopNavigation_row2_submenuContainer");
        elRow.classList.add("row");
        elCol.classList.add("col-12", "V2_TopNavigation_row2_submenuColumn");
        // Dodaj elementy do [elCol]
        elCol.appendChild(elSubmenu);
        elCol.appendChild(elBanner);
        // Dodaj elementy do [submenuWrapper]
        this.submenuWrapper.appendChild(elLogotypes);
        this.submenuWrapper.appendChild(elCloseButton);
        //this.submenuWrapper.appendChild(elSubmenu)
        //this.submenuWrapper.appendChild(elBanner)
        this.submenuWrapper.style.setProperty('--offset-top', `${this.rowWrapper.clientHeight}px`);
        this.submenuWrapper.style.setProperty('--opacity', '1');
        this.submenuWrapper.classList.add("submenuIsVisible");
        //this.masonry(elSubmenu)
    }
    hideSubmenu() {
        //return
        this.submenuWrapper.style.setProperty('--offset-top', `0`);
        this.submenuWrapper.style.setProperty('--opacity', '0');
        setTimeout(() => {
            this.submenuWrapper.classList.remove("submenuIsVisible");
            this.submenuWrapper.innerHTML = "";
        }, this.getSubmenuTransitionDurationMs());
    }
    removeClassFromElement(o, className) {
        // HTMLElement
        if (this.isElement(o)) {
            //console.log(`HTMLElement`)
            const element = o;
            element.classList.remove(className);
        }
        // HTMLElement collection
        else if (this.isElementCollection(o)) {
            //console.log(`HTMLElement collection`)
            const elements = o;
            for (var i = 0; i < elements.length; i++) {
                elements.item(i).classList.remove(className);
            }
        }
        // Node
        else if (this.isNode(o)) {
            //console.log(`node`)
            const node = o;
            node.classList.remove(className);
        }
        // Node collection
        else if (this.isNodeCollection(o)) {
            //console.log(`Node collection`)
            const elements = o;
            elements.forEach((element) => {
                element.classList.remove(className);
            });
        }
    }
    countClicksOnElement(el) {
        var result = 0;
        if (el) {
            el.dataset.countClicks = el.dataset.countClicks ? `${parseInt(el.dataset.countClicks) + 1}` : "1";
            result = parseInt(el.dataset.countClicks);
        }
        return result;
    }
    countClicksOnElementReset(o) {
        // HTMLElement
        if (this.isElement(o)) {
            //console.log(`HTMLElement`)
            const element = o;
            element.dataset.countClicks = "";
        }
        // HTMLElement collection
        else if (this.isElementCollection(o)) {
            //console.log(`HTMLElement collection`)
            const elements = o;
            for (var i = 0; i < elements.length; i++) {
                elements.item(i).dataset.countClicks = "";
            }
        }
        // Node
        else if (this.isNode(o)) {
            //console.log(`node`)
            const node = o;
            node.dataset.countClicks = "";
        }
        // Node collection
        else if (this.isNodeCollection(o)) {
            //console.log(`Node collection`)
            const elements = o;
            elements.forEach((element) => {
                element.dataset.countClicks = "";
            });
        }
    }
    isNode(o) {
        return (typeof Node === "object" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string");
    }
    isNodeCollection(o) {
        return NodeList.prototype.isPrototypeOf(o);
    }
    isElement(o) {
        return (typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
    }
    isElementCollection(o) {
        return HTMLCollection.prototype.isPrototypeOf(o);
    }
    masonry(target) {
        // Programmatically get the column width
        const itemIdentifier = ".V2_TopNavigation_row2_submenuL0_ItemWrapper";
        let item = document.querySelector(itemIdentifier);
        let parentWidth = item.parentElement.getBoundingClientRect().width;
        //let itemWidth = item.getBoundingClientRect().width + parseFloat(getComputedStyle(item).marginLeft) + parseFloat(getComputedStyle(item).marginRight);
        let itemWidth = item.getBoundingClientRect().width - parseFloat(getComputedStyle(item).gap);
        let columnWidth = Math.round((1 / (itemWidth / parentWidth)));
        //console.log(parseFloat(getComputedStyle(item).gap))
        // We need this line since JS nodes are dumb
        let arrayOfItems = Array.prototype.slice.call(document.querySelectorAll(itemIdentifier));
        let trackHeights = {};
        arrayOfItems.forEach(function (item) {
            // Get index of item
            let thisIndex = arrayOfItems.indexOf(item);
            // Get column this and set width
            let thisColumn = thisIndex % columnWidth;
            if (typeof trackHeights[thisColumn] == "undefined") {
                trackHeights[thisColumn] = 0;
            }
            trackHeights[thisColumn] += item.getBoundingClientRect().height + parseFloat(getComputedStyle(item).marginBottom);
            // If the item has an item above it, then move it to fill the gap
            if (thisIndex - columnWidth >= 0) {
                let getItemAbove = document.querySelector(`${itemIdentifier}:nth-of-type(${thisIndex - columnWidth + 1})`);
                let previousBottom = getItemAbove.getBoundingClientRect().bottom;
                let currentTop = item.getBoundingClientRect().top - parseFloat(getComputedStyle(item).marginBottom);
                item.style.top = `-${currentTop - previousBottom}px`;
                item.classList.add("V2_TopNavigation_row2_submenuL0_ItemWrapper_NotFirstRow");
            }
        });
        //console.log(trackHeights)
        //let max = Math.max(...Object.values(trackHeights));
        //target.style.height = `${max}px`;
    }
}
new Zepter_V2_TopNavigation_MainMenu();

class Zepter_V2_TopNavigation_MobileMenu {
    constructor() {
        this.container = document.getElementById("V2_TopNavigation_Wrapper");
        this.elSwitchButton = document.getElementById("V2_TopNavigation_Row1_MobileMenuSwitch_Button_Body");
        this.elWrapper = null;
        this.elDrawer = null;
        this.elCloseButton = null;
        this.elZepterLogo = null;
        this.elFunctions = null;
        this.elRefInfo = null;
        this.elMenu = null;
        this.elAdditionalMenu = null;
        this.elAccountMenu = null;
        this.elSaleByAffSelector = null;
        this.elWrapperAnimDur = 250;
        this.elDrawerAnimDur = 250;
        this.animShortend = 100;
        this.menuMaxLevel = 4;
        // Jeśli brak wymaganych do pracy kontenerów
        if (!this.container || !this.elSwitchButton) {
            // Przerwij działanie
            return;
        }
        // Obsługa pokaż/ukryj/przełącz
        document.body.addEventListener("Zepter_V2_TopNavigation_MobileMenu_Show", () => { this.showDrawer(); });
        document.body.addEventListener("Zepter_V2_TopNavigation_MobileMenu_Hide", () => { this.hideDrawer(); });
        document.body.addEventListener("Zepter_V2_TopNavigation_MobileMenu_Switch", () => { this.switchDrawer(); });
        // Wyrenderuj mobilne menu
        this.renderMobileMenu();
        // Dodaj akcję do przełącznika (hamburgera)
        this.elSwitchButton.addEventListener("click", () => {
            document.body.dispatchEvent(new Event("Zepter_V2_TopNavigation_MobileMenu_Switch"));
        });
        // Dodaj akcje do [elWrapper]
        this.elWrapper.addEventListener("click", (e) => {
            if (e.target.classList.contains("V2_TopNavigation_mobile_wrapper")) {
                document.body.dispatchEvent(new Event("Zepter_V2_TopNavigation_MobileMenu_Switch"));
            }
        });
        // Dodaj akcje do [window]
        window.addEventListener("resize", () => { this.hideDrawer(); });
        window.addEventListener("orientationchange", () => { this.hideDrawer(); });
    }
    renderMobileMenu() {
        // Stwórz elementy
        this.elWrapper = document.createElement("div");
        // Konfiguruj elementy
        this.elWrapper.classList.add("V2_TopNavigation_mobile_wrapper");
        // Dodaj do DOM
        document.body.prepend(this.elWrapper);
        this.elWrapper.appendChild(this.renderDrawer());
        this.elDrawer.appendChild(this.renderCloseButton());
        this.elDrawer.appendChild(this.renderZepterLogo());
        if (this.renderRefInfo()) {
            this.elDrawer.appendChild(this.elRefInfo);
        }
        if (this.renderFunctions()) {
            this.elDrawer.appendChild(this.elFunctions);
        }
        this.elDrawer.appendChild(this.renderMenu());
        if (this.renderSaleByAffSelector()) {
            this.elMenu.prepend(this.elSaleByAffSelector);
        }
        if (this.renderAccountMenu()) {
            this.elMenu.append(this.elAccountMenu);
        }
    }
    renderDrawer() {
        // Stwórz elementy
        this.elDrawer = document.createElement("div");
        // Konfiguruj elementy
        this.elDrawer.classList.add("V2_TopNavigation_mobile_drawerWrapper");
        // Zwróć element
        return this.elDrawer;
    }
    renderCloseButton() {
        // Stwórz element
        this.elCloseButton = document.createElement("button");
        // Konfiguruj element
        this.elCloseButton.innerText = "X";
        this.elCloseButton.classList.add("V2_TopNavigation_mobile_closeButton");
        this.elCloseButton.addEventListener("click", () => { this.hideDrawer(); });
        // Zwróć element
        return this.elCloseButton;
    }
    renderZepterLogo() {
        // Pobierz oryginalne logo
        const elZepterLogoOrigin = document.getElementById("V2_TopNavigation_Row1_ZepterLogo");
        // Jeśli brak źródłowego elementu z logo
        if (!elZepterLogoOrigin) {
            return null;
        }
        // Stwórz element
        this.elZepterLogo = document.createElement("img");
        // Konfiguruj element
        this.elZepterLogo.src = elZepterLogoOrigin.src;
        this.elZepterLogo.classList.add("V2_TopNavigation_mobile_zepterLogoImage");
        this.elZepterLogo.addEventListener("click", () => {
            this.hideDrawer();
            window.open("/", "_self");
        });
        // Zwróć element
        return this.elZepterLogo;
    }
    renderFunctions() {
        var _a, _b, _c, _d;
        // Pobierz oryginalne logo
        const elFunctionsOrigin = document.getElementById("V2_TopNavigation_row1_wrapperMenu");
        // Jeśli brak źródłowego elementu z logo
        if (!elFunctionsOrigin) {
            return null;
        }
        // Stwórz element
        this.elFunctions = document.createElement("div");
        // Konfiguruj element
        this.elFunctions.classList.add("V2_TopNavigation_mobile_functionsWrapper");
        // First level origin items
        const elFunctionsOriginLi = (_b = (_a = elFunctionsOrigin.getElementsByClassName("V2_TopNavigation_Row1_OptionsMenu_List_Wrapper")) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.children;
        // Jeśli lista z funkcjami jest pusta
        if (!elFunctionsOriginLi) {
            return null;
        }
        // Przetwarzaj elementy z funkcjami
        //elFunctionsOrigin.querySelectorAll("li").forEach((liOrigin) => {
        for (let liOrigin of elFunctionsOriginLi) {
            // Wybierz tylko [node], które jest elementem html
            if (liOrigin.nodeType == 1 && liOrigin.firstElementChild) {
                // Kolnuj oryginalny element z menu dla PC
                const elItem = liOrigin.firstElementChild.cloneNode(true);
                // Jeśli element posiada w sobie <a> usuń z niego klasę
                // Nie jest potrzebna, ponieważ powoduje powtórzenie ramki z wersji PC
                // np. w przycisku "wyloguj" oraz w innych w których jest używana metoda [form post]
                (_c = elItem.querySelector("a")) === null || _c === void 0 ? void 0 : _c.removeAttribute("class");
                // Ustal czy ten item jest ikonką koszyka
                const isCartItem = (_d = liOrigin.getAttribute("class")) === null || _d === void 0 ? void 0 : _d.match(/Cart/i);
                // Usuń oryginalne klasy CSS i dodaj nowe dla menu mobilnego
                elItem.removeAttribute("class");
                elItem.classList.add("V2_TopNavigation_mobile_functionsItem");
                if (isCartItem) {
                    elItem.classList.add("ItemCart");
                }
                // Aktywuj kliknięcie
                elItem.addEventListener("click", () => {
                    var _a;
                    //console.log(elItemOrigin.querySelector("a"))
                    //elItemOrigin.querySelector("a")?.dispatchEvent( new Event("click") )
                    (_a = liOrigin.querySelector("a")) === null || _a === void 0 ? void 0 : _a.click();
                });
                // Dodaj przygotowany [item] do wrappera z funkcjami
                this.elFunctions.appendChild(elItem);
            }
        }
        // Zwróć element
        return this.elFunctions;
    }
    renderMenu() {
        // Ustal element z menu data
        const menuData = document.getElementById("V2_TopNavigation_Row2_MenuData");
        // Jeśli brak elementu z menu data
        if (!menuData) {
            return null;
        }
        // Stwórz element
        this.elMenu = document.createElement("div");
        // Konfiguruj element
        this.elMenu.classList.add("V2_TopNavigation_mobile_menuWrapper");
        // Funkcja dla [level 0]
        const fnMenuItems = (ulOrigin, menuLevel = 0) => {
            // Stwórz wrapper dla tego poziomu menu
            const levelWrapper = document.createElement("div");
            // Konfiguruj wrapper
            levelWrapper.classList.add("V2_TopNavigation_mobile_menuLevelWrapper", `V2_TopNavigation_mobile_menuLevelWrapperL${menuLevel}`);
            // Ostatni element <a>
            let elALast;
            // Przetwarzaj elementy z funkcjami
            ulOrigin.childNodes.forEach((liOrigin) => {
                // Wyszukaj tylko elementy HTML
                if (liOrigin.nodeType == 1) {
                    // Przetwarzaj dzieci elementu HTML
                    liOrigin.childNodes.forEach((elOrigin) => {
                        if (elOrigin.nodeType === 1) {
                            //console.log(elOrigin.nodeName.toLowerCase())
                            // Jeśli dziecko jest typu <a>
                            if (elOrigin.nodeName.toLowerCase() == "a") {
                                // Stwórz element
                                const elA = document.createElement("a");
                                elALast = elA;
                                // Konfiguruj element
                                elA.classList.add(`V2_TopNavigation_mobile_menuLevelWrapperL${menuLevel}_itemAnchor`);
                                elA.href = elOrigin.href;
                                elA.innerText = elOrigin.innerText.trim();
                                // Ustaw licznik kliknięć w <a>
                                elA.dataset.clickCounter = "0";
                                // Obsługa kliknięcia
                                elA.addEventListener("click", (e) => {
                                    // Jeśli link posiada submenu i nie był jeszczae klinięty
                                    if (elA.dataset.hasSubmenu && parseInt(elA.dataset.clickCounter) === 0) {
                                        // Blokuj standardową akcję
                                        e.preventDefault();
                                        // Zwiększ lincznik kliknięć o jeden
                                        elA.dataset.clickCounter = `${parseInt(elA.dataset.clickCounter) + 1}`;
                                        // Pokaż submenu
                                        elA.nextElementSibling.classList.add("isVisible");
                                    }
                                });
                                // Dodaj do wrappera
                                levelWrapper.appendChild(elA);
                            }
                            // Jeśli dziecko jest typu <ul> (submenu)
                            else if (elOrigin.nodeName.toLowerCase() == "ul" && elOrigin.classList.contains("submenu") && menuLevel < this.menuMaxLevel) {
                                elALast.dataset.hasSubmenu = "true";
                                levelWrapper.appendChild(fnMenuItems(elOrigin, menuLevel + 1));
                            }
                        }
                    });
                }
            });
            // Zwróć wrapper z elementami menu
            return levelWrapper;
        };
        // Rozpocznij przetwarzanie menu
        this.elMenu.appendChild(fnMenuItems(menuData));
        // Dodaj additional menu
        if (this.renderAdditionalMenu()) {
            this.elMenu.appendChild(this.elAdditionalMenu);
        }
        // Zwróć element
        return this.elMenu;
    }
    renderAdditionalMenu() {
        var _a;
        // Jeśli brak elementu z menu data
        if (!this.container.getElementsByClassName("V2_TopNavigation_row3_menu")) {
            return null;
        }
        // Ustal originalny obiekt z additional menu (z wersji PC)
        const additionalMenuData = this.container.getElementsByClassName("V2_TopNavigation_row3_menu").item(0);
        // Jeśli brakuje oryginalnego obiektu
        if (!additionalMenuData) {
            return null;
        }
        // Stwórz element
        this.elAdditionalMenu = document.createElement("div");
        // Konfiguruj element
        this.elAdditionalMenu.classList.add("V2_TopNavigation_mobile_additionalMenu_wrapper");
        // Przetwarzaj elementy źródłowe
        (_a = additionalMenuData.querySelectorAll("li")) === null || _a === void 0 ? void 0 : _a.forEach((elItemOrigin) => {
            var _a;
            if (elItemOrigin.nodeType === 1) {
                const itemOriginA = elItemOrigin.querySelector("a");
                // Jeśli oryginalny <a> istnieje
                if (itemOriginA) {
                    // Stwórz elementy
                    const elItemWrapper = document.createElement("div");
                    const elItemIcon = document.createElement("div");
                    const elItemLabel = document.createElement("div");
                    // Ustal kolor linku
                    let linkColor = "#000";
                    const elItemOriginStyle = elItemOrigin.querySelector("a") ? getComputedStyle(elItemOrigin.querySelector("a")) : null;
                    if (elItemOriginStyle) {
                        linkColor = elItemOriginStyle.getPropertyValue("--item-color").trim();
                    }
                    if (linkColor.match(new RegExp("^#000.*", "im"))) {
                        elItemIcon.style.filter = "invert(1)";
                    }
                    else {
                        elItemLabel.style.color = linkColor;
                    }
                    // Aktywuj kliknięcie
                    elItemWrapper.addEventListener("click", () => {
                        var _a;
                        //console.log(elItemOrigin.querySelector("a"))
                        //elItemOrigin.querySelector("a")?.dispatchEvent( new Event("click") )
                        (_a = elItemOrigin.querySelector("a")) === null || _a === void 0 ? void 0 : _a.click();
                    });
                    // Konfiguruj wrapper
                    elItemWrapper.classList.add("V2_TopNavigation_mobile_additionalMenu_item_wrapper");
                    // Konfiguruj label
                    elItemLabel.classList.add("V2_TopNavigation_mobile_additionalMenu_item_label");
                    elItemLabel.innerText = (_a = elItemOrigin.querySelector("[class='V2_TopNavigation_row3_menuItemLabel']")) === null || _a === void 0 ? void 0 : _a.textContent.trim();
                    // Konfiguruj ikonkę
                    elItemIcon.classList.add("V2_TopNavigation_mobile_additionalMenu_item_icon");
                    if (elItemOrigin.querySelector("img")) {
                        elItemIcon.appendChild(elItemOrigin.querySelector("img").cloneNode());
                        elItemWrapper.appendChild(elItemIcon);
                    }
                    // Dodaj elementy do DOM
                    this.elAdditionalMenu.appendChild(elItemWrapper);
                    elItemWrapper.appendChild(elItemLabel);
                }
            }
        });
        // Zwróć element
        return this.elAdditionalMenu;
    }
    renderAccountMenu() {
        var _a, _b, _c;
        // Ustal kontener z oryginalnym submenu dla account
        const elAccountSubmenuOrigin = document.getElementById("V2_TopNavigation_Row1_OptionsMenu_Account_Submenu_List_Wrapper");
        // Jeśli brak elementu z menu data
        if (!elAccountSubmenuOrigin) {
            return null;
        }
        const fnIsSelected = (hrefUrl) => {
            const urlData = new URL(hrefUrl);
            const currentPageUrl = new URL(document.location.href);
            //console.log(hrefUrl, urlData.pathname, currentPageUrl.pathname, urlData.pathname == currentPageUrl.pathname)
            return urlData.pathname == currentPageUrl.pathname;
        };
        // Stwórz klon oryginalnego elementu
        this.elAccountMenu = elAccountSubmenuOrigin.cloneNode(true);
        this.elAccountMenu.removeAttribute("id");
        this.elAccountMenu.style.display = "";
        // Konfiguruj <ul> L0
        this.elAccountMenu.setAttribute("class", "V2_TopNavigation_mobile_AccountMenu_L0_Wrapper");
        // Przetwarzaj <li> L0
        for (var elIndexL0 in this.elAccountMenu.children) {
            if (parseInt(elIndexL0) >= 0 && this.elAccountMenu.children.item(parseInt(elIndexL0))) {
                // Konfiguruj <li> L0
                const elItemL0 = this.elAccountMenu.children.item(parseInt(elIndexL0));
                elItemL0.setAttribute("class", "V2_TopNavigation_mobile_AccountMenu_L0_Item");
                // Ustal <ul> L1
                const elWrapperL1 = (_a = elItemL0.getElementsByTagName("ul")) === null || _a === void 0 ? void 0 : _a.item(0);
                // Konfiguruj <a> L0
                const elAL0 = (_b = elItemL0.getElementsByTagName("a")) === null || _b === void 0 ? void 0 : _b.item(0);
                if (elAL0) {
                    elAL0.removeAttribute("class");
                    elAL0.classList.add("V2_TopNavigation_mobile_AccountMenu_L0_Link");
                    fnIsSelected(elAL0.href) ? elAL0.classList.add("V2_TopNavigation_mobile_AccountMenu_L0_Link_Selected") : null;
                    // Ustal URL dla elementu <a>
                    const urlAL0 = new URL(elAL0.href);
                    // Dodaj ikonkę do <a> L0
                    const elIconL0 = document.createElement("img");
                    elIconL0.style.display = "inline-block";
                    elIconL0.width = 20;
                    elIconL0.height = 20;
                    elIconL0.style.filter = "invert(1)";
                    if (urlAL0.pathname == "/Account/MyAccount") {
                        elIconL0.src = "/Content/Images/Icons/material/person_FILL1_wght400_GRAD0_opsz24.svg";
                        elAL0.prepend(elIconL0);
                    }
                    else if (urlAL0.pathname == "/Orders") {
                        elIconL0.src = "/Content/Images/Icons/material/list_alt_FILL0_wght400_GRAD0_opsz24.svg";
                        elAL0.prepend(elIconL0);
                    }
                    else if (urlAL0.pathname == "/Account/AffiliateProgramAboutMe") {
                        elIconL0.src = "/Content/Images/Icons/material/handshake_FILL0_wght400_GRAD0_opsz24.svg";
                        elAL0.prepend(elIconL0);
                    }
                    else if (elItemL0.dataset.linkToPersonalWebShop) {
                        elIconL0.src = "/Content/Images/Icons/material/storefront_FILL0_wght400_GRAD0_opsz24.svg";
                        elAL0.prepend(elIconL0);
                    }
                    // Jeśli ten <a> w menu posiada submenu <ul>
                    if (elWrapperL1) {
                        // Ustaw obsługę sekwencji kliknięć w <a>
                        this.clickCounterSet({
                            target: elAL0, sequence: [
                                // Kliknięcie #0
                                (evClick, elTarget) => {
                                    //console.log("Call click origin action 0")
                                    // Pokaż submenu <ul>
                                    elWrapperL1.style.display = "";
                                },
                                // Kliknięcie #1
                                //(evClick: MouseEvent, elTarget: HTMLElement) => {
                                //    //console.log("Call click origin action 1")
                                //}
                            ]
                        });
                    }
                }
                // Konfiguruj <ul> L1
                if (elWrapperL1) {
                    elWrapperL1.setAttribute("class", "V2_TopNavigation_mobile_AccountMenu_L1_Wrapper");
                    elWrapperL1.style.display = "none";
                    // Przetwarzaj <li> L1
                    for (var elIndexL1 in elWrapperL1.children) {
                        if (parseInt(elIndexL1) >= 0 && elWrapperL1.children.item(parseInt(elIndexL1))) {
                            // Konfiguruj <li> L1
                            const elItemL1 = elWrapperL1.children.item(parseInt(elIndexL1));
                            elItemL1.setAttribute("class", "V2_TopNavigation_mobile_AccountMenu_L1_Item");
                            // Konfiguruj <a> L1
                            const elAL1 = (_c = elItemL1.getElementsByTagName("a")) === null || _c === void 0 ? void 0 : _c.item(0);
                            if (elAL1) {
                                elAL1.removeAttribute("class");
                                elAL1.classList.add("V2_TopNavigation_mobile_AccountMenu_L1_Link");
                                fnIsSelected(elAL1.href) ? elAL1.classList.add("V2_TopNavigation_mobile_AccountMenu_L1_Link_Selected") : null;
                            }
                        }
                    }
                }
            }
        }
        // Zwróć element
        return this.elAccountMenu;
    }
    renderRefInfo() {
        // Pobierz oryginalne logo
        const elRefInfoOrigin = document.getElementById("V2_TopNavigation_Row2_Ref_Wrapper");
        // Jeśli brak źródłowego elementu z logo
        if (!elRefInfoOrigin) {
            return null;
        }
        // Zapisz element
        this.elRefInfo = elRefInfoOrigin.cloneNode(true);
        this.elRefInfo.id = `${this.elRefInfo.id}_Mobile`;
        // Modyfikuj elRefInfo
        this.elRefInfo.style.flexDirection = "column";
        this.elRefInfo.style.textAlign = "center";
        this.elRefInfo.style.lineHeight = "1.5";
        this.elRefInfo.style.height = "min-content";
        // Modyfikuj refDetails
        const refDetails = this.elRefInfo.querySelector("[class=\"V2_TopNavigation_Row2_Ref_Details\"]");
        if (refDetails) {
            refDetails.style.flexDirection = "column";
        }
        // Ustaw zdarzenie click
        this.elRefInfo.addEventListener("click", () => {
            elRefInfoOrigin.dispatchEvent(new Event("click"));
        });
        // Zwróć klon elementu
        return this.elRefInfo;
    }
    renderSaleByAffSelector() {
        var _a;
        // Jeśli istnieje roletka buy/sell dla aff
        const elSaleByAffSelector = this.container.getElementsByClassName("V2_TopNavigation_Row2_SaleByAffiliateSelector_Wrapper");
        // Jeśli istnieje roletka buy/sell dla aff
        if (elSaleByAffSelector) {
            // Stwórz klon roletki
            const elSaleByAffelectorClone = (_a = elSaleByAffSelector.item(0)) === null || _a === void 0 ? void 0 : _a.cloneNode(true);
            // Jeśli klon istnieje
            if (elSaleByAffelectorClone) {
                // Zaktualizuj ID roletki aby nie pokrywało się z ID w menu w wersji dla PC
                elSaleByAffelectorClone.querySelector("select").id = `${elSaleByAffelectorClone.querySelector("select").id}Mobile`;
                // Dodaj klon roletki do wrappera z funkcjami
                this.elSaleByAffSelector = elSaleByAffelectorClone;
            }
        }
        return this.elSaleByAffSelector;
    }
    switchDrawer() {
        if (this.elWrapper.classList.contains("isVisible")) {
            this.hideDrawer();
        }
        else {
            this.showDrawer();
        }
    }
    showDrawer() {
        document.body.classList.add("disable-scroll");
        this.elWrapper.classList.add("isVisible");
        setTimeout(() => {
            this.elWrapper.classList.add("isOpacity1");
            setTimeout(() => {
                this.elDrawer.classList.add("isVisible");
                setTimeout(() => {
                    //console.log("Drawer is opened")
                }, this.elDrawerAnimDur);
            }, this.elWrapperAnimDur - this.animShortend);
        }, 0);
    }
    hideDrawer() {
        this.elDrawer.classList.remove("isVisible");
        setTimeout(() => {
            this.elWrapper.classList.remove("isOpacity1");
            setTimeout(() => {
                this.elWrapper.classList.remove("isVisible");
                document.body.classList.remove("disable-scroll");
                //console.log("Drawer is hidden")
            }, this.elWrapperAnimDur);
        }, this.elDrawerAnimDur - this.animShortend);
    }
    clickCounterSet(props) {
        // Obsługa zdarzenia "click"
        props.target.addEventListener("click", (evClick) => {
            // Ustal cel
            const elTarget = evClick.currentTarget;
            // Jeśli cel istnieje
            if (elTarget) {
                // Oblicz aktualny stan licznika kliknięć
                const clickCounter = parseInt(elTarget.dataset.clickCounter) >= 0 ? parseInt(elTarget.dataset.clickCounter) + 1 : 0;
                // Zaktualizuj stan licznika w dataset elementu
                elTarget.dataset.clickCounter = `${clickCounter}`;
                // Jeśli istnieje metoda (funkcja) w sekwencji dla tego stanu licznika kliknięć
                if (props.sequence[clickCounter]) {
                    // Wstrzymaj domyślne zachowanie się elementu przy zdarzeniu "click"
                    evClick.preventDefault();
                    // Spróbuj wykonać metodę (funkcję) przyporządkowaną do tego stanu licznika kliknięć
                    try {
                        props.sequence[clickCounter](evClick, elTarget);
                    }
                    catch (e) {
                        // Jeśli nie udało się wykonać metody (funkcji) - pokaż [warn] w konsoli
                        console.warn(`Unable to call click counter sequence #${clickCounter}. Details:`, e);
                    }
                }
            }
        }, { once: true });
    }
}
// Uruchom klasę zarządzającą górnym elementem nawigacyjnym
//window.addEventListener('DOMContentLoaded', (event) => {
//    window.setTimeout(() => {
new Zepter_V2_TopNavigation_MobileMenu();
//    }, 1000)
//})

class Zepter_V2_TopNavigation_OptionsMenu {
    constructor() {
        // Obsługa ikonki koszyka
        this.CartController();
        // Obsługa ikonki wyszukiwarki
        this.SearchController();
    }
    CartController() {
        // Ustal element zawierający licznik produktów w koszyku
        const elCounters = document.getElementsByClassName("V2_TopNavigation_Row1_OptionsMenu_Cart_Counter");
        // Jesli element z licznikiem istnieje
        if (elCounters) {
            // Nasłuchuj zmian stanu koszyka
            document.addEventListener("updatecart", () => {
                // Zaktualizuj licznik produktów w koszyku pobierając ilość z backendu
                //console.log("updatecart")
                const xhttp = new XMLHttpRequest();
                xhttp.onload = function () {
                    var _a;
                    //console.log(this.responseText, document.getElementById("V2_TopNavigation_Row1_MenuItemCart_Counter").innerHTML)
                    //document.getElementById("V2_TopNavigation_Row1_MenuItemCart_Counter").innerHTML = this.responseText?.trim();
                    //console.log(this.responseText, document.getElementById("V2_TopNavigation_Row1_MenuItemCart_Counter").innerHTML)
                    //const elCounters = document.getElementsByClassName("V2_TopNavigation_row1_menuItemCart_counter")
                    //console.log(elCounters)
                    // Przetwórz wszystkie elementy zawierające liczbę produktów w koszyku
                    for (var i = 0; i < elCounters.length; i++) {
                        // Zaktualizuj licznik ilości produktów w koszyku
                        elCounters.item(i).innerHTML = (_a = this.responseText) === null || _a === void 0 ? void 0 : _a.trim();
                    }
                };
                xhttp.open("POST", "/Checkout/GetShoppingCartItemsCount", true);
                xhttp.send();
            });
        }
    }
    SearchController() {
        var _a, _b;
        // Ustal element z elementami wyszukiwarki
        const elOrigin = document.getElementById("V2_TopNavigation_Search_Popup_Content");
        // Jeśli element źródłowy nie istnieje
        if (!elOrigin) {
            // Przerwij tę metodę
            return;
        }
        // Stwórz klon element
        const elOriginCloned = elOrigin.cloneNode(true);
        // Usuń [display: none] ze sklonowanego elementu
        elOriginCloned.style.display = "";
        // Ustal przycisk otwierający wyszukiwarkę
        const elSearchButton = (_a = document.getElementsByClassName("V2_TopNavigation_Row1_OptionsMenu_List_Item_Wrapper_Search")) === null || _a === void 0 ? void 0 : _a.item(0);
        // Ustaw akcję kliknięcia w przycisk wyszukiwania
        (_b = elSearchButton === null || elSearchButton === void 0 ? void 0 : elSearchButton.querySelector("a")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", () => {
            setTimeout(() => {
                elOriginCloned.getElementsByClassName("V2_SearchModal_Input_Body").item(0).focus();
            }, 1000);
            // Ustawienia modala
            let modalProps = {
                modalId: `OptionsMenu_Modal_${Math.floor(Math.random() * 100)}`,
                modalSize: "md",
                modalCloseButton: true,
                modalCloseuttonColor: "white",
                modalTitle: elSearchButton.dataset.searchModalTitle,
                //modalTitle: elItemWithModal.querySelector("a")?.innerText.trim(),
                modalHeaderAlign: "center",
                modalHeaderBgColor: "black",
                modalHeaderTextColor: "white",
                modalDialogCentered: true,
                modalBody: elOriginCloned,
            };
            // Otwórz modal
            if (Modal) {
                const modal = new Modal(modalProps);
                modal.show();
                window.setTimeout(() => {
                    var _a, _b;
                    (_b = (_a = document.getElementsByClassName("V2_SearchModal_Input_Body")) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.dispatchEvent(new Event("focus"));
                    //console.log((document.getElementsByClassName("V2_SearchModal_Input_Body").item(0) as HTMLInputElement).focus())
                }, 1000);
            }
        });
    }
}
new Zepter_V2_TopNavigation_OptionsMenu();


class Zepter_V2_TopNavigation_RefInfo {
    constructor() {
        var _a;
        this.elContainer = document.getElementById("V2_TopNavigation_Row2_StartWrapper");
        this.elRefWrapper = document.getElementById("V2_TopNavigation_Row2_Ref_Wrapper");
        this.elRefDetailsPopupData = document.getElementById("V2_TopNavigation_Row2_Ref_Details_Popup_Data");
        // Jeśli brakuje nadrzędnego kontenera
        if (!this.elContainer) {
            // Zakończ działanie klasy
            return;
        }
        // Jeśli brakuje elementu z ref info
        if (!this.elRefWrapper) {
            this.elContainer.style.display = "none";
            (_a = document.getElementById("V2_TopNavigation_Row2_RowWrapper")) === null || _a === void 0 ? void 0 : _a.classList.add("V2_TopNavigation_row2_rowWrapper_noRefInfo");
            //this.elContainer.remove()
        }
        // Jeśli istnieje element z ref info
        else {
            // Jeśli istnieje element z danymi dodatkowymi o ref
            if (this.elRefDetailsPopupData) {
                // Zdarzenie click na wrapperze ref info
                this.elRefWrapper.addEventListener("click", () => {
                    this.showRefInfoPopup();
                });
            }
        }
    }
    showRefInfoPopup() {
        var _a, _b;
        // Jeśli użytkownik nie posiada żadnych portali społeczniośiowych
        if (this.elRefDetailsPopupData.getElementsByClassName("V2_TopNavigation_Row2_Ref_Details_Popup_Item_Data_Community_Icon_Wrapper").length === 0) {
            // Usuń cały wiersz z portalami społecznościowymi
            (_b = (_a = this.elRefDetailsPopupData.getElementsByClassName("V2_TopNavigation_Row2_Ref_Details_Popup_Item_Wrapper_Community")) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.remove();
        }
        // Ustawienia modala
        let modalProps = {
            modalId: `RefInfo_Modal`,
            modalSize: "md",
            modalCloseButton: true,
            modalCloseuttonColor: "white",
            modalTitle: this.elRefDetailsPopupData.dataset.popupTitle,
            modalHeaderAlign: "center",
            modalHeaderBgColor: "black",
            modalHeaderTextColor: "white",
            modalDialogCentered: true,
            modalBody: this.elRefDetailsPopupData
        };
        // Otwórz modal
        try {
            const modal = new Modal(modalProps);
            modal.show();
        }
        catch (e) {
            console.warn("Modal mechanism is currently not available, please try again little later", e);
        }
    }
}
new Zepter_V2_TopNavigation_RefInfo();//# sourceMappingURL=TopNavigation.js.map
